import request from "@/utils/request";

export function queryPersonListById(data){
  return request({
    url:'/osp/customer/queryPersonListById',
    method:'post',
    data: data
  })
}

export function queryCustomersBySalerId(data){
  return request({
    url:'/osp/person/queryCustomerListById',
    method:'post',
    data:data
  })
}

export function queryCustomerLinkmanById(data){
  return request({
    url:'/osp/customer/queryCustomerLinkmanById',
    method:'post',
    data:data
  })
}

export function queryCustomerSaleInfoById(data){
  return request({
    url:'/osp/customer/querySaleInfoById',
    method:'post',
    data:data
  })
}


export function getBalanceAmount(data){
  return request({
    url: '/osp/online-order/getBalanceAmount',
    method:'post',
    data:data
  })
}

export function getCustomersByCompany(data){
  return request({
    url:'/osp/customerCompanyInfo/queryCustomers',
    method:'post',
    data:data
  })
}

export function queryCenterSettle(data){
  return request({
    url:'/osp/customer/getSalCustoSaleorgById',
    method:'post',
    data:data
  })
}
